import assetLoader from "@utils/internalImageLoder";

export const HERO_SECTION_DATA = {
  desktop: {
    title: "Browse cars as per your interest",
    wishlistButtonText: "Your car shortlist",
    savingButtonText: "in your wallet",
  },
  mobile: {
    wishlistText: "Your car shortlist",
    savingHeadText: "New car savings balance",
    searchBarText: "Which car are you looking for?",
  },
  savingModal: {
    image: `${assetLoader()}/icons/savingModalCar.svg`,
    alt: "savingModalCarImage",
    heading: "You have ",
    headingAfterSpan: " in your New Car savings wallet",
    contentHeading: "This is your exclusive ",
    contentHeadingSpan: "savings wallet for buying a car on ACKO Drive.",
    points: [
      "We'll add ₹500 every 3 months.",
      "Use it to save more on your car purchase",
    ],
    buttonText: "Understood",
  },
}; 